// src/pages/FAQ.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import aboutSec2 from '../assets/img/core-img/about-sec2.jpg';

export default function FAQ() {
  useEffect(() => {
    const $ = window.$;

    // — FAQ accordion: hide all, open first, bind toggles —
    if ($) {
      const $dts = $('.info-faq-area dt');
      const $dds = $('.info-faq-area dd');

      // hide all answers
      $dds.hide();
      $dts.removeClass('active');

      // open first question
      $dts.first().addClass('active').next('dd').show();

      // bind click
      $dts.off('click').on('click', function() {
        const $dt = $(this);
        // toggle this one
        $dt.toggleClass('active').next('dd').stop(true,true).slideToggle(300);
        // close siblings
        $dt.siblings('dt').removeClass('active').next('dd').stop(true,true).slideUp(300);
      });
    }

    // — Re-init WOW.js (for fadeInUp animations) —
    if (window.WOW) {
      new window.WOW().init();
    }
  }, []);

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcumb-area clearfix auto-init">
        <div className="breadcumb-content">
          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12">
                <nav aria-label="breadcrumb" className="breadcumb--con text-center">
                  <h2 className="w-text title wow fadeInUp" data-wow-delay="0.2s">FAQ</h2>
                  <ol className="breadcrumb justify-content-center wow fadeInUp" data-wow-delay="0.4s">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">FAQ</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Area */}
      <div className="faq-timeline-area section-padding-100" id="faq">
        <div className="container">
          <div className="section-heading text-center">
            <span>Important Translation Questions</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Translation FAQs</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              Find answers to common questions about our translation and localization services.
            </p>
          </div>
          <div className="row align-items-center">
            {/* Image */}
            <div className="col-12 col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-sm-10 offset-sm-1">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp" data-wow-delay="0.4s">
                <img src={aboutSec2} alt="Translation FAQ" />
              </div>
            </div>
          {/* Q&A List */}
          <div className="col-12 col-lg-6 col-md-12">
            <div className="info-faq-area mt-s">
              <dl style={{ marginBottom: 0 }}>
                {[
                  {
                    q: 'What turnaround time can I expect for my translation?',
                    a: 'Most Indic and globally rare-language projects are delivered within 1–3 business days. Ultra-rare or large-volume projects may take longer—our team will provide a precise ETA.'
                  },
                  {
                    q: 'How do you ensure translation accuracy and quality?',
                    a: 'Each project is translated by a certified native linguist specializing in the target Indic or rare language, then proofread by a senior editor for consistency and readability.'
                  },
                  {
                    q: 'Which languages and industries do you support?',
                    a: 'We specialize in India’s major languages—Hindi, Bengali, Tamil, Telugu, Marathi, Gujarati, Kannada, Malayalam, Odia, Punjabi—and a wide range of low-resource and rare languages worldwide. Our industry expertise spans legal, medical, technical, marketing, e-commerce, manufacturing, and more.'
                  },
                  {
                    q: 'Do you provide certified or notarized translations?',
                    a: 'Yes. We supply certified translations for Indic and rare languages recognized by courts and government bodies, and can arrange notarization upon request.'
                  },
                  {
                    q: 'How is confidential or sensitive content handled?',
                    a: 'We sign NDAs and use secure file transfer plus encrypted storage to protect your data at every stage of the translation process.'
                  }
                ].map((item, i) => (
                  <React.Fragment key={i}>
                    <dt className="wave fadeInUp" data-wow-delay={`${0.2 + 0.1 * i}s`}>{item.q}</dt>
                    <dd className="fadeInUp" data-wow-delay={`${0.3 + 0.1 * i}s`}><p>{item.a}</p></dd>
                  </React.Fragment>
                ))}
              </dl>
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}
